import { ADD_STATIC_INDICATION } from './actionTypes';

const addStaticIndication = staticIndication => ({ type: ADD_STATIC_INDICATION, payload: staticIndication });

export default addStaticIndication;
